import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Col, Row, Typography } from 'antd';
import busksellerdetail from '@modules/Busk/Busk-Seller-Detail/services/busksellerdetail';
import { useParams } from 'react-router';

interface Props {
  formData: any;
}

const SignUpDate = ({ formData }: Props) => {
  const formatDate = formatDateTime(formData?.createdAt);
  const { id } = useParams<{ id: string }>();

  const handelExportExcel = async () => {
    const response = await busksellerdetail.exportAll(id);
    const outputFilename = `Seller_all_240406T9g6QGJSxyR.zip`;

    const url = URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div
      style={{
        padding: '1rem',
        backgroundColor: 'white',
        marginBottom: '2rem'
      }}
    >
      <Row>
        <Col flex={10} style={{ paddingTop: '5px' }}>
          가입일 {formatDate}
          <Typography.Text
            style={{
              padding: '.5rem 2rem',
              borderRadius: '1rem',
              marginLeft: '10px'
            }}
          >
            {formData?.state}
          </Typography.Text>
        </Col>
        <Col flex={0.1}>
          <Typography.Text
            style={{
              background: 'rgb(43, 44, 81)',
              padding: '0.5rem 2rem',
              borderRadius: '1rem',
              color: 'white',
              marginLeft: '10px'
            }}
            onClick={handelExportExcel}
          >
            {formData?.active ? '활성' : '중지'}
          </Typography.Text>
        </Col>
      </Row>
    </div>
  );
};

export default SignUpDate;
